import { render, staticRenderFns } from "./safe-recordwwdetail.vue?vue&type=template&id=f5295414&scoped=true&"
import script from "./safe-recordwwdetail.vue?vue&type=script&lang=js&"
export * from "./safe-recordwwdetail.vue?vue&type=script&lang=js&"
import style0 from "./safe-recordwwdetail.vue?vue&type=style&index=0&id=f5295414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5295414",
  null
  
)

export default component.exports